import Main from "./components/Main.vue";
import CategoryChildren from "./components/CategoryChildren.vue";
import Search from "./components/Search.vue";
import Company from "./components/Company.vue";

const slugs = SLUGS;
const company = slugs.company;
const search = slugs.search;
const by = slugs.by;
const word = slugs.word;
const category = slugs.category;
const categories = slugs.categories;

const routes = [
  {
    path: "/",
    component: Main,
    name: "main",
    pathToRegexpOptions: { strict: true },
    children: [
      {
        name: "categories",
        path: "/" + categories + "/",
        pathToRegexpOptions: { strict: true },
      },
      {
        path: category + "/:id/",
        pathToRegexpOptions: { strict: true },
        components: {
          children: CategoryChildren,
        },
        name: "category",
      },
    ],
  },
  {
    path: "/" + search + "/" + category + "/:id/",
    component: Search,
    name: "search",
    pathToRegexpOptions: { strict: true },
    children: [
      {
        name: "company",
        path: company + "/:company_id/",
        pathToRegexpOptions: { strict: true },
        components: {
          company: Company,
        },
      },
    ],
  },
  {
    path: "/" + search + "/" + by + "/" + word + "/",
    component: Search,
    pathToRegexpOptions: { strict: true },
    name: "search_by_word",
    children: [
      {
        name: "company_found_by_word",
        path: company + "/:company_id/",
        pathToRegexpOptions: { strict: true },
        components: {
          company: Company,
        },
      },
    ],
  },
];

export default routes;
